import axiosapi from "./axiosAPI";

// Get All Posts
export const getAllPosts = async (
    setPosts,
    setFetcherror,
    fetcherror,
)=>{
	try{
		const res =await axiosapi.get("/posts");
        setPosts(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Posts");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Posts");
		}
		
	}
	
};



// GetOnePost
export const getOnePost = async (
    pkid,
    setFetcherror,
    post,   
    setPost
    
)=>{
	try{
		const res =await axiosapi.get(`/posts/${pkid}`);
        setPost(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Post");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Post");
		}
		
	}
	
};


// Create New Post
export const createPost = async (
    e,
    postTitle,
    postContent,
    setFetcherror,
    setPostTitle,
    setPostContent

) => {
    
    return new Promise(async (resolve, reject) => {
        let postres = {};
        let finalData = null;
        let badrequest = false;

        e.preventDefault();

        if (!postTitle || !postContent) {
            reject({ badrequest: true }); 
            return;
        }

        const PushItem = {
            title: postTitle,
            content: postContent,
        };


        try {
            const res = await axiosapi.post("/posts", PushItem);
            finalData = res.data;
            setPostTitle("");
            setPostContent("");

            postres = {
                finalData,
                badrequest,
            };

            resolve(postres); 

        }
        catch (err) {
            if (err.response) {
                //Error Obtained from Backend not in 200
                console.log(err.response.data);
                console.log(err.response.status);
                console.log(err.response.headers);
                badrequest = true;
                setFetcherror("Could Not Create New Post");
                reject(err);
			
            } else {
                //No response Obtained from the server.
                console.log(`Error: ${err.message}`);
                reject(err.message);
            }
		
        }
    });	
};




export const editPost = async (
    e,
    postpkid,
    postTitle,
    postContent,
    setPostTitle,
    setPostContent,
    fetcherror,
    setFetcherror,
    handleAllToasts
              
        ) => {
            e.preventDefault();

            if (!postTitle || !postContent) {
                handleAllToasts(2, "Either Title or Content Missing"); 
                    return;
                    
                }

            const PushItem = {

                    id:postpkid,
                    title: postTitle,
                    content: postContent,
                };

            try{
                const res =await axiosapi.patch("/posts/",PushItem );
                setPostTitle("");
                setPostContent("");
                handleAllToasts(1, "Post Updated Successfully");
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Create New Post");
                    handleAllToasts(2, "Could Not update The Post");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Create New Post");
                    handleAllToasts(2, "Could Not update The Post");
                    
                }
                
            }
            
};



// Delete Existing Post.

export const deletePost = async (
    pkid,
    setPosts,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/posts/${pkid}`);
        let finalData = res.data.message;
        getAllPosts(setPosts, setFetcherror);
        handleAllToasts(1, "Post Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Post no Such Item");
            handleAllToasts(2,"Could Not Delete Post no Such Item");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Post no Such Item");
            handleAllToasts(2,"Could Not Delete Post no Such Item");
		}
		
	}
	
};